// extractAirportCode — pure derivation of an airport code from a destination string.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (the
// `extractAirportCode` helper) as part of the behavior-preserving refactor
// (issue #240). The container uses it for `getDefaultDepartureAirport` /
// `getDefaultArrivalAirport`, passing the result to the flight search/lookup
// sub-forms. Given a destination string it returns the upper-cased, trimmed
// value when it looks like an airport code (≤ 4 chars, letters only), otherwise
// the empty string.
//
// Totality mirrors the source EXACTLY:
//   - `destination.trim().toUpperCase()` is copied verbatim. The source did NOT
//     guard against a non-string `destination` (it is always sourced from the
//     controlled string inputs `startDestination` / `endDestination`), so NO
//     extra guard is added here.
//   - The code test `dest.length <= 4 && /^[A-Z]+$/.test(dest)` is identical,
//     including returning '' for the empty/non-matching case.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Derive a candidate airport code from a destination string.
 *
 * @param {string} destination - The destination text (e.g. 'Dallas, TX' or 'DFW').
 * @returns {string} The upper-cased code when it looks like one, else ''.
 */
export function extractAirportCode(destination) {
  const dest = destination.trim().toUpperCase();
  if (dest.length <= 4 && /^[A-Z]+$/.test(dest)) {
    return dest;
  }
  return '';
}

export default extractAirportCode;
